window.Page = {

    openButtons    : document.querySelectorAll('.js-wine-button'),
    closeButtons   : document.querySelectorAll('.js-wine-close'),
    relatedButtons : document.querySelectorAll('.js-related'),
    rooms          : document.querySelectorAll('.js-wine-overlay'),

    mainImages    : document.querySelectorAll('.wine-img'),
    relatedImages : document.querySelectorAll('.wine-related-img'),

    activeOverlay  : null,

    // Let's launch this thing
    liftoff : () => {
        Page.showOverlayOnButtonClick()
        Page.closeOverlayOnButtonClick()
        Page.switchOverlayOnRelatedClick()
        Page.bounceClickOnImages()

        window.addEventListener('load' , () => {
            Page.activateUrlWhenParamIsPresentInUrl()
        })
    },

    // My new function block
    showOverlayOnButtonClick : () => {
        
        Page.openButtons.forEach(button => {
            button.addEventListener('click' , () => {

                // Prevent the main document from scrolling
                document.body.classList.add('overlay-is-open');

                // Display the overlay
                Page.activeOverlay = document.getElementById(button.value);
                Page.activeOverlay.classList.add('is-visible')

            })
        })

    },

    // Close the overlay and scroll back when the X is pressed
    closeOverlayOnButtonClick : () => {

        Page.closeButtons.forEach(button => {
            button.addEventListener('click' , () => {

                // Prevent the main document from scrolling
                document.body.classList.remove('overlay-is-open');

                // Display the overlay
                Page.activeOverlay.classList.remove('is-visible');
                Page.activeOverlay = null;

            })
        })

    },

    // Change overlay on click
    switchOverlayOnRelatedClick : () => {

        Page.relatedButtons.forEach(button => {
            button.addEventListener('click' , () => {

                // Hide the previously visible overlay
                Page.activeOverlay.classList.remove('is-visible')

                // Display the overlay
                Page.activeOverlay = document.getElementById(button.value);
                Page.activeOverlay.classList.add('is-visible')

            })
        })

    },

    // Bounce the clicks when images are pressed
    bounceClickOnImages : () => {

        Page.mainImages.forEach(image => {
            image.addEventListener('click' , () => {
                image.parentElement.nextElementSibling.firstElementChild.click()
            })
        })

        Page.relatedImages.forEach(image => {
            image.addEventListener('click' , () => {
                image.parentElement.previousElementSibling.click()
            })
        })

    },

    // Activate overlay when param is in the URL
    activateUrlWhenParamIsPresentInUrl : () => {

        // Grab the content of the URL and check if there is a parameter
        const searchParams = new URLSearchParams(window.location.search);

        // If we don't have a parameter we can silently leave
        if (!searchParams.has("uuid")) return;

        // If we do have a parameter fetch it
        let uuid = searchParams.get("uuid");

        // Now grab the button with the same id and then press it
        document.querySelector(`button[value="wine-${uuid}"]`).click()

        // Clean up the URL
        window.history.replaceState({}, document.title, window.location.pathname);

    }

};

Page.liftoff()